<template>
  <div v-if="isOpen" class="internal-settings">
    <div v-if="hotelPms">
      <PmwParagraph
        size="paragraph-80"
        weight="light"
        class="internal-settings--title"
      >
        Integração
      </PmwParagraph>
      <div class="container-input">
        <!-- CÓDIGO PMS -->
        <PmwFormInput
          v-if="hotelPms !== 'ESO'"
          v-model="value.codigoPMS"
          :tooltipMinWidth="250"
          infoText="Para integração com PMS, define o código desta tarifa no sistema do hotel, para integração de reservas."
          inputPaddingLeft="0"
          label="Código PMS"
          size="small"
          infoIcon
          @input="pmsInput"
        />

        <!-- ADICIONAR OPÇÕES -->
        <PmwFormSelect
          v-else
          v-model="selectedPms"
          :options="pmsOptions"
          :toggleAll="false"
          infoText="Para integração com PMS, define o código desta tarifa no sistema do hotel, para integração de reservas."
          label="Código PMS"
          size="small"
          infoIcon
          @input="selectHandler"
        />

        <!-- INPUT PENSAO -->
        <PmwFormSelect
          v-model="selectedTipoPensao"
          :options="pensaoTypeOptions"
          :infoIcon="true"
          :required="isPensionMandatory"
          tooltipMinWidth="236"
          infoText="Pensão é obrigatório para hotéis integrados com Hits e Alpha"
          size="small"
          label="Pensão"
          placeholder="Selecione um tipo"
          @input="$emit('tipoPensaoValue', selectedTipoPensao.value)"
        />
      </div>

      <SeparateLine :left="0" :right="0" />
    </div>

    <!-- QUARTOS -->
    <PmwParagraph
      size="paragraph-80"
      weight="light"
      class="internal-settings--title"
    >
      Apartamentos com essa flutuação
    </PmwParagraph>

    <div class="internal-settings--wrapper">
      <PmwInputCheckbox
        v-for="item in rooms"
        :value="isRoomSelected(item.codigo)"
        :checked="isRoomSelected(item.codigo)"
        :key="item.codigo"
        :label="item.nome"
        class="internal-settings--checkbox"
        @input="inputHandler($event, item.codigo)"
      />
    </div>
  </div>
</template>

<script>
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwInputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/PmwInputCheckbox'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'

export default {
  name: 'InternalSettings',

  components: {
    PmwFormInput,
    PmwFormSelect,
    PmwInputCheckbox,
    PmwParagraph,
    SeparateLine
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    },

    hotelPms: {
      type: String,
      default: ''
    },

    rooms: {
      type: Array,
      default: () => []
    },

    isOpen: {
      type: Boolean,
      default: false
    },

    tipoPensao: {
      type: Number,
      default: 1
    }
  },

  computed: {
    /** Se o hotel tiver PMS "Hits" ("APP") ou "Alpha" ("ALP") o campo "Pensão" deve ser obrigatório */
    isPensionMandatory() {
      return this.hotelPms === 'APP' || this.hotelPms === 'ALP'
    }
  },

  data() {
    return {
      pmsOptions: [
        { text: 'CAFE', value: 'CAFE' },
        { text: 'CAFE SEM PARQUE', value: 'CAFE SEM PARQUE' },
        { text: 'MAP', value: 'MAP' },
        { text: 'MAP SEM PARQUE', value: 'MAP SEM PARQUE' },
        { text: 'FAP', value: 'FAP' },
        { text: 'FAP SEM PARQUE', value: 'FAP SEM PARQUE' }
      ],

      selectedPms: [],

      selectedTipoPensao: null,

      pensaoTypeOptions: [
        { value: 1, text: 'Sem pensão' },
        { value: 2, text: 'Café da manhã' },
        { value: 3, text: 'MAP' },
        { value: 4, text: 'FAP' },
        { value: 5, text: 'All inclusive' }
      ]
    }
  },

  watch: {
    tipoPensao: {
      handler(newVal) {
        const selected = this.pensaoTypeOptions.find(
          (option) => option.value === newVal
        )
        this.selectedTipoPensao = selected || null
      }
    },

    'value.codigoPMS': {
      handler(newVal) {
        if (this.hotelPms === 'ESO' && newVal !== '' && newVal !== null) {
          this.selectedPms = this.pmsOptions.find(
            (item) => item.value === newVal
          )
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    /**
     * Passa os dados para o value
     * @param {boolean} event: se o quarto foi selecionado
     * @param {number} id: ID do quarto
     */
    inputHandler(event, codigo) {
      /** Remove itens */
      if (event === false) {
        let idx = -1

        idx = this.value.quartos.findIndex((item) => item === codigo)

        if (idx > -1) {
          this.value.quartos.splice(idx, 1)
        }
      } else {
        this.value.quartos.push(codigo)
      }

      this.$emit('selectedRooms', this.value.quartos)
    },

    /**
     * Passa o PMS selecionado para o value
     * @param {object} event: opção selecionada
     */
    selectHandler(event) {
      this.value.codigoPMS = event.value
    },

    /**
     * Adiciona o valor do input de código PMS ao value
     * @param {string} event: valor inserido
     */
    pmsInput(event) {
      this.value.codigoPMS = event === '' ? null : event
    },

    /**
     * Verifica se o ID do quarto está no array de quartos selecionados
     * @param {number} roomId: ID do quarto
     * @returns index do id no array
     */
    isRoomSelected(roomId) {
      return this.value.quartos?.findIndex((item) => item === roomId) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
.internal-settings {
  &--title {
    margin: 25px 0 35px;
  }
  &--wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }
  &--checkbox {
    min-width: 250px;
  }
}
.container-input {
  display: flex;
  gap: 20px;
  align-items: center;
}
</style>
